<template lang="pug">
  div.container
    el-row.zIndex
      el-col.col1(
        :class="{'errorMapa' : errors.length}"
      )
        appMapa(
          @removerGeometria='removerGeometria'
          ref="mapa"
          idMapa="mapaCentralGeo",
          height="65vh",
          :mapLayersConfigs="layers"
          :featureLayerConfig="featureLayerConfig"
          :buttons="buttonsConfig"
        )

        app-resumable(
          ref="resumable",
          :target="urlUpload",
          :fileType="validExtensions",
          idInput="upload",
          :fileTypeErrorCallback="fileTypeErrorCallback"
          @onSuccess="onSuccess",
          @onError="onError",
          @onProgress="onProgress",
          @fileAdded="onFileAdded"
        )

</template>

<script>
import AppMapa from '@/components/AppMapa'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppResumable from '@/components/AppResumable'
import { mapActions } from 'vuex'
import layerStyles from '@/utils/layerStyles'

export default {

  components: {
    AppMapa,
    AppResumable
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    localizacoes: {
      required: false,
      type: Array
    },

    errors: {
      required: true,
      type: Array
    },
    idMapa: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      validExtensions: ['zip'],

      urlUpload: this.$rotas.PUBLICO.UPLOAD,

      featureLayerConfig: {
        url: process.env.URL_MAPSERVER_MUNICIPIOS,
        style: layerStyles.ESTADO,
        popup: (layer) => `${layer.feature.properties.NM_MUNICIP}`
      }
    }
  },

  computed: {
    layers () {
      if (!this.localizacoes) return []

      let layers = []
      for (let indice = 0; indice < this.localizacoes.length; indice++) {
        const container =
              '<button id="remover-geometria-button[' + indice + ']" class="button-popup" ' +
              'style="background-color: #fff; border: none; border-radius: 10px; ' +
              'color: #EF4836; text-align: center; padding: 10px; cursor: pointer; font-size:14px;" ' +
              'onmouseover="this.style.color=\'#FFF \'; this.style.backgroundColor=\'#EF4836\'";' +
              'onmouseout="this.style.color=\'#EF4836\'; this.style.backgroundColor=\'#FFF\'";>' +
              '<i class="el-icon-delete"></i>' +
              '&nbsp Remover Geometria</button>'; // eslint-disable-line

        const config = {
          minWidth: 100,
          closeButton: true
        }

        const layerConfig = {
          geoJson: this.localizacoes[indice],
          popup: {container, config},
          idGeometria: indice
        }

        layers.push(layerConfig)
      }

      return layers
    },
    buttonsConfig () {
      return [
        {
          id: 'centralizar',
          icon: 'fa-crosshairs',
          tooltip: 'Centralizar',
          onClick: this.centerMap
        },
        {
          id: 'upload',
          icon: 'fa-upload',
          tooltip: 'Enviar shapefile'
        }
      ]
    }
  },

  methods: {
    ...mapActions({
      resetLoader: 'loader/resetLoader',
      setLoaderWithText: 'loader/setLoaderWithText',
      calculateIntersect: 'cadastro/calculoIntersectGeoCentral'
    }),

    centerMap () {
      this.$refs.mapa.recenterView()
    },

    clean () {
      this.resetLoader()
    },

    fileTypeErrorCallback () {
      this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
        this.$messages.ARQUIVO_EXTENSION_FAIL.replace('$$', this.validExtensions.join(', ')))
    },

    async onSuccess (value, fileKey) {
      // TODO realizar requisição para realizar sobreposição com os municípios
      this.clean()
      this.setLoaderWithText({
        status: true,
        text: 'Calculando interseções'
      })

      try {
        const data = {
          fileKey
        }

        const response = await this.calculateIntersect(data)

        this.resetLoader()

        this.atualizarGeorreferenciamento(response)
      } catch (error) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERRO, error.message)

        this.resetLoader()
      }
    },

    onFileAdded (file) {
      this.$refs.resumable.uploadFile()
    },

    removerGeometria (idGeometria) {
      this.localizacoes.splice(idGeometria, 1)
    },

    atualizarGeorreferenciamento (georreferenciamento) {
      this.localizacoes.push(georreferenciamento.geom)
    },

    onError (message) {
      this.clean()
      this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, message)
    },

    onProgress (progress) {
      this.setLoaderWithText({
        status: true,
        text: `${progress}% concluído...`
      })
    }
  }

}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.removeArrecadacaoGeo {
  position: absolute;
  top: 105px;
  background-color: white;
  padding: 8px;
  border-radius: 4px;
  cursor: pointer;
  left: 10px;
  z-index: 400;
  display: flex;
  align-content: center;
  i {
    color: black;
    font-size: 12px;
  }

  &:focus {
    outline: none;
  }
}

.errorMapa {
  border: 2px solid $error;
  border-radius: 13px;
}

.zIndex {
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/screens/central/components/Mapa.vue